module.exports = __webpack_public_path__ + "9d4ad712e0a46f7e72e98ec2620366d4.pdf";